<section class="custom" id="desarrollo-a-medida">
  <div class="custom__container">
    <div class="custom__text">
      <p class="custom__kicker">Desarrollo a medida</p>
      <h2 class="custom__title">
        Lo que el estándar no cubre, lo desarrollamos
      </h2>
      <p class="custom__lead">
        Sobre la misma plataforma, sin migrar tus datos ni duplicar
        información. Ganas capacidades a medida y las mantienes conectadas al
        resto de tu operativa.
      </p>
      <ul class="custom__points">
        @for (p of puntos; track p.label) {
          <li class="custom__point">
            <app-hex-icon [color]="p.color" [size]="20" [height]="22" />
            {{ p.label }}
          </li>
        }
      </ul>
      <a routerLink="/contacto" class="custom__cta">Cuéntanos tu caso</a>
    </div>

    <!-- Hexágono punteado con "+": la pieza que aún no existe -->
    <div class="custom__figure" aria-hidden="true">
      <div class="custom__glow"></div>
      <svg viewBox="0 0 200 210" class="custom__hex">
        <path
          d="M100 8 L182 52 L182 150 L100 192 L18 150 L18 52 Z"
          fill="none"
          stroke="var(--ts-card-bd)"
          stroke-width="2.5"
          stroke-dasharray="7 7"
          stroke-linejoin="round" />
        <path
          d="M100 30 L163 63 L163 137 L100 170 L37 137 L37 63 Z"
          fill="color-mix(in srgb, var(--ts-primary) 12%, transparent)"
          stroke="var(--ts-primary)"
          stroke-width="2.5"
          stroke-linejoin="round" />
        <line x1="100" y1="88" x2="100" y2="112"
          stroke="var(--ts-primary)" stroke-width="6" stroke-linecap="round" />
        <line x1="88" y1="100" x2="112" y2="100"
          stroke="var(--ts-primary)" stroke-width="6" stroke-linecap="round" />
      </svg>
    </div>
  </div>
</section>
